<flow-chart-container [title]="'peopleCount.ageGenderDistribution' | translate" [hasData]="hasData">
  <ng-container slot="compare">
     <div class="flex" *ngIf="!compare">
      <span *ngIf="startDate === endDate">{{startDate}}</span>
      <span *ngIf="startDate !== endDate">{{startDate}} - {{endDate}}</span>
    </div>

    <div *ngIf="compare">
      <span class="pr-8">{{ "global.compareWeeks" | translate }}</span>
      <span class="pr-5">{{ 'peopleCount.week' | translate }} {{ weekNumber }}: {{ startDate }} — {{ endDate }}</span>
      <span>{{ 'peopleCount.week' | translate }} {{ weekNumberCompare }}: {{ compareStartDate }} — {{ compareEndDate }}</span>
    </div>
  </ng-container>

  <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-5 auto-rows-fr items-center">
    <flow-age-gender-distribution-doughnut-chart
      [data]="data?.totals"
      [dataCompare]="data?.totalsCompare"
      [weekNumber]="weekNumber"
      [weekNumberCompare]="weekNumberCompare"
      [compare]="compare"
      [timeframeType]="timeframeType"></flow-age-gender-distribution-doughnut-chart>

    <flow-age-gender-distribution-bar-chart
      [data]="data?.distribution"
      [dataCompare]="data?.distributionCompare"
      [weekNumber]="weekNumber"
      [weekNumberCompare]="weekNumberCompare"
      [compare]="compare"
      [timeframeType]="timeframeType"></flow-age-gender-distribution-bar-chart>
  </div>
</flow-chart-container>
